// interface ServerConfiguration{
//     server:
// }
export default {
    serverURI: {
        development: 'http://localhost:8014',
        production: '',
    },
};
